<template>
  <v-row align="center">
    <v-col cols="12" md="6">
      <div class="hero-text">
        <div class="hero-badge">
          <v-icon small class="mr-1" color="error">mdi-cash-multiple</v-icon>
          Programa de Revenda
        </div>

        <h1 class="headline-text mt-3">
          Revenda o ZaperMenu e ganhe comissão recorrente
        </h1>

        <p class="subheadline-text mt-4">
          A revenda autorizada parceira recebe até 80% do valor da primeira mensalidade de cada cliente
          e comissão recorrente, que cresce conforme a sua carteira aumenta.
        </p>

        <ul class="hero-bullets mt-5">
          <li v-for="(b, i) in bullets" :key="i">
            <v-icon small color="success" class="mr-2">mdi-check-circle</v-icon>{{ b }}
          </li>
        </ul>

        <div class="mt-6">
          <CtaButton secao="simulador">Simular meus ganhos</CtaButton>
        </div>
      </div>
    </v-col>

    <v-col cols="12" md="6" class="d-flex justify-center">
      <div class="earnings-card" aria-hidden="true">
        <div class="earnings-card__header">
          <v-icon small color="error" class="mr-2">mdi-wallet-outline</v-icon>
          Seus ganhos como revenda
        </div>

        <div class="earnings-row">
          <div>
            <span class="earnings-row__label">Na venda</span>
            <span class="earnings-row__desc">da 1ª mensalidade de cada cliente</span>
          </div>
          <span class="earnings-row__value">até 80%</span>
        </div>

        <div class="earnings-divider" />

        <div class="earnings-row earnings-row--top">
          <div>
            <span class="earnings-row__label">Todo mês</span>
            <span class="earnings-row__desc">comissão recorrente sobre a carteira</span>
          </div>
          <v-icon color="success">mdi-trending-up</v-icon>
        </div>

        <div class="bars">
          <div
            v-for="(h, i) in bars"
            :key="i"
            class="bars__bar"
            :style="{ height: `${h}%`, animationDelay: `${i * 120}ms` }"
          />
        </div>
        <div class="bars__axis">
          <span>clientes na carteira</span>
          <v-icon x-small color="currentColor">mdi-arrow-right</v-icon>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
  import CtaButton from '@/components/CtaButton.vue';

  export default {
    name: 'RevendaHero',

    components: {
      CtaButton,
    },

    data: () => ({
      bullets: [
        'Até 80% da primeira mensalidade',
        'Comissão recorrente todo mês',
        'Percentual maior conforme a carteira cresce',
      ],
      bars: [22, 36, 52, 70, 100],
    }),
  };
</script>

<style lang="scss" scoped>
  .hero-text {
    width: 92%;
    margin: 0 auto;

    @media (max-width: 780px) {
      width: 100%;
    }
  }

  .hero-badge {
    display: inline-flex;
    align-items: center;
    padding: 5px 14px;
    border-radius: 999px;
    border: 1px solid rgba(244, 6, 18, 0.35);
    background: rgba(244, 6, 18, 0.08);
    font-size: 13px;
    font-weight: 600;
    color: #f40612;
    letter-spacing: 0.02em;
  }

  .headline-text {
    font-size: 50px;
    font-weight: 700;
    line-height: 1.1;

    background: linear-gradient(90deg, #f40612 0%, #ff4d1a 25%, #ffb347 50%, #ff4d1a 75%, #f40612 100%);
    background-size: 250% auto;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    animation: headline-shimmer 4s linear infinite;

    @media (max-width: 780px) {
      font-size: 36px;
    }
  }

  @keyframes headline-shimmer {
    0%   { background-position: 0% center; }
    100% { background-position: 250% center; }
  }

  .subheadline-text {
    font-size: 17px;
    font-weight: 400;
    line-height: 1.75;
    color: var(--text-secondary);
    border-left: 3px solid rgba(244, 6, 18, 0.4);
    padding-left: 14px;
    margin: 0;

    @media (max-width: 780px) {
      font-size: 15px;
    }
  }

  .hero-bullets {
    list-style: none;
    padding: 0;
    margin: 0;

    li {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: var(--text-secondary);
      margin-bottom: 8px;
    }
  }

  /* ── Card de ganhos ── */
  .earnings-card {
    width: 100%;
    max-width: 440px;
    padding: 26px 26px 20px;
    border-radius: 20px;
    background: var(--card-bg);
    border: 1px solid var(--card-border);
    box-shadow: 0 16px 48px rgba(0, 0, 0, 0.25);
    animation: hero-float 6s ease-in-out infinite;
  }

  @keyframes hero-float {
    0%,100% { transform: translateY(0); }
    50%     { transform: translateY(-7px); }
  }

  .earnings-card__header {
    display: flex;
    align-items: center;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--text-muted);
    margin-bottom: 20px;
  }

  .earnings-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    &--top {
      align-items: flex-start;
    }

    &__label {
      display: block;
      font-size: 17px;
      font-weight: 700;
      color: var(--text-primary);
    }

    &__desc {
      display: block;
      font-size: 13px;
      color: var(--text-muted);
      margin-top: 2px;
    }

    &__value {
      font-size: 34px;
      font-weight: 800;
      line-height: 1;
      white-space: nowrap;
      color: #23cf65;

      @media (max-width: 600px) {
        font-size: 28px;
      }
    }
  }

  .earnings-divider {
    height: 1px;
    background: var(--card-border);
    margin: 20px 0;
  }

  .bars {
    display: flex;
    align-items: flex-end;
    gap: 10px;
    height: 120px;
    margin-top: 18px;

    &__bar {
      flex: 1;
      border-radius: 8px 8px 3px 3px;
      background: linear-gradient(180deg, #23cf65 0%, rgba(35, 207, 101, 0.35) 100%);
      transform-origin: bottom;
      animation: bar-grow 0.7s ease-out both;
    }

    &__axis {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 4px;
      margin-top: 8px;
      font-size: 12px;
      color: var(--text-hint);
    }
  }

  @keyframes bar-grow {
    from { transform: scaleY(0); }
    to   { transform: scaleY(1); }
  }
</style>
